export default "__VITE_PUBLIC_ASSET__5869a83c__"